var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"136px","min-width":"136px"}},[_c('div',{staticClass:"mb-2 mt-3 text-capitalize font-weight-regular endDateFont",attrs:{"align":"left"}},[_c('CustomFieldItems',{attrs:{"selectedTask":_vm.item,"header":_vm.header,"placement":'list'}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }